import React from 'react'
import { VideoLoaderContainer, Spinner } from './styles'

interface VideoPlayerLazyProps {
    isLoading?: boolean
    error?: Error | null
    pastDelay?: boolean
}

const VideoLoader: React.FC<VideoPlayerLazyProps> = () => {
    return (
        <VideoLoaderContainer>
            <Spinner />
        </VideoLoaderContainer>
    )
}

export default VideoLoader
